import {
  IAluno,
  IFiltroRelatorioNotaConferencia,
  schemaFiltroRelatorioNotaConferencia,
  listaRelatoriosBoletinsConferencia,
  IRelatorioNotaConferencia,
  IModeloRelatorioNotaConferencia,
  yupFiltroRelatorioNotaConferencia,
  modeloRelatorioConferenciaNotasParciaisModelo1,
} from "@deltasge/marauders-map";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormGroup,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import {
  RadioboxBlank as RadioBlankIcon,
  RadioboxMarked as RadioMarkedIcon,
  FileCog as ConfigIcon,
} from "mdi-material-ui";
import { Form } from "assets/styleds";
import { snack } from "components/GlobalSnackbar";
import { api, Environment } from "configs";
import React, { FC, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useAppSelector } from "store";
import { getError } from "utils";
import * as styles from "assets/styles/form";
import { getDefault, PageConfig } from "./PageConfig";
import { useDialog } from "hooks/useDialog";
import { useMobile } from "hooks/useMobile";
import qs from "qs";

export const BoletinsConferencias: FC<{
  close: () => void;
  anoLetivo?: number;
  idCurso: number;
  idSerie: number;
  idTurma: number;
  idAluno?: number;
  idMateria?: number;
  etapa?: number;
  modelo?: IModeloRelatorioNotaConferencia;
  relatorio?: IRelatorioNotaConferencia;
}> = ({
  close,
  idCurso,
  idSerie,
  idTurma,
  idAluno,
  idMateria,
  modelo: modeloInit,
  relatorio: relatorioInit,
  etapa,
  anoLetivo,
}) => {
  const {
    configPapelPadrao,
    escola,
    configuracoes: { etapas },
    usuario: { usuario },
    layout: { devMode },
    sistemaAvaliacao: { data: sistemaAvaliacao },
  } = useAppSelector((state) => state);

  const isSm = useMobile("sm");

  const [alunos, setAlunos] = useState<{
    loading: boolean;
    data: IAluno[];
  }>({
    loading: false,
    data: [],
  });
  const [papel, setPapel] = useState(getDefault(configPapelPadrao));
  const [inHtml, setInHtml] = useState(false);
  const [retDados, setRetDados] = useState(false);
  const [submiting, setSubmiting] = useState(false);

  const {
    formState: { errors },
    control,
    watch,
    setValue,
    handleSubmit,
  } = useForm<IFiltroRelatorioNotaConferencia>({
    resolver: yupResolver(schemaFiltroRelatorioNotaConferencia),
    defaultValues: {
      anoLetivo: anoLetivo?.toString() || escola.anoSite,
      etapa,
      idAluno:
        modeloInit?.id == modeloRelatorioConferenciaNotasParciaisModelo1.id
          ? undefined
          : idAluno,
      idCurso,
      idMateria,
      idSerie,
      idTurma,
      idModelo: modeloInit?.id,
      idRelatorio: relatorioInit?.id,
      methodName: relatorioInit?.methodName,
      fileName: modeloInit?.fileName,
      dataEmissao: new Date(),
    },
  });

  const { idModelo, idRelatorio } = watch();

  const etapasFiltradas = etapas
    .filter((f) => f.idsCursos?.includes(idCurso))
    .sort((a, b) => a.etapa - b.etapa);

  const relatorio = listaRelatoriosBoletinsConferencia.find(
    (f) => f.id == idRelatorio
  );
  const modelo = relatorio?.modelos.find((f) => f.id == idModelo);

  const {
    RenderDialog: PageConfigDialog,
    hide: hidePageConfig,
    show: openPageConfig,
  } = useDialog({
    title: "Configurar Página",
    options: {
      modal: true,
      scroll: "paper",
      maxWidth: "sm",
    },
  });

  useEffect(() => {
    let ativo = true;
    const controller = new AbortController();
    (async () => {
      try {
        setAlunos((p) => ({ ...p, loading: true }));
        const {
          data: [data],
        } = await api.get<[IAluno[], number]>("aluno/matriculados", {
          cache: { ignoreCache: true },
          params: {
            where: {
              matriculas: { idTurma },
            },
            select: ["nome", "uid", "nrChamada"],
            order: {
              nrChamada: "ASC",
            },
          },
        });
        if (ativo) setAlunos((p) => ({ ...p, data }));
      } catch (error) {
        if (ativo) snack.error(getError(error));
      } finally {
        if (ativo) {
          setAlunos((p) => ({ ...p, loading: false }));
        }
      }
    })();
    return () => {
      ativo = false;
      controller.abort();
    };
  }, [idTurma]);

  useEffect(() => {
    if (modelo?.habilita?.includes("controleNotas")) {
      setValue("controleNotas", true);
    } else {
      setValue("controleNotas", false);
    }
  }, [modelo?.habilita]);

  const handleSelectRel = (
    relatorio: IRelatorioNotaConferencia,
    modelo?: IModeloRelatorioNotaConferencia
  ) => {
    if (!modelo) modelo = relatorio.modelos[0];

    setValue("methodName", relatorio.methodName);
    setValue("idRelatorio", relatorio.id);
    setValue("fileName", modelo.fileName);
    setValue("idModelo", modelo.id);

    Object.values(modelo.habilita).forEach((element) => {
      const field = schemaFiltroRelatorioNotaConferencia.fields[element];
      if (field.type == "boolean") {
        setValue(element, false);
      }
    });
  };

  const onSubmit = (data: IFiltroRelatorioNotaConferencia) => {
    try {
      setSubmiting(true);

      const configPagina = {
        width: `${papel.width}mm`,
        height: `${papel.height}mm`,
        marginTop: `${papel.marginTop}mm`,
        marginBottom: `${papel.marginBottom}mm`,
        marginLeft: `${papel.marginLeft}mm`,
        marginRight: `${papel.marginRight}mm`,
      };

      const url = Environment.RELATORIO_API_URL.concat("/api/")
        .concat(escola.codigo)
        .concat("/relatorios/notas-conferencia/?")
        .concat(
          qs.stringify({
            ...data,
            ...configPagina,
            authorization: usuario?.token,
            html: devMode && inHtml,
            retDados: devMode && retDados,
          })
        );
      window.open(url);
    } catch (error) {
      snack.error(getError(error));
    } finally {
      setSubmiting(false);
    }
  };

  return (
    <>
      <Box sx={{ height: "100%", overflow: "auto", width: "100%" }}>
        <PageConfigDialog>
          <PageConfig
            item={papel}
            handleClose={(data) => {
              if (data) setPapel(data);
              hidePageConfig();
            }}
          />
        </PageConfigDialog>
        <DialogContent dividers style={{ paddingBottom: 0 }}>
          <Form
            noValidate
            id="relatorio-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Grid container spacing={2}>
              {devMode && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      ...styles.fieldset,
                      p: 1,
                      mb: 1,
                    }}
                  >
                    <Typography variant="subtitle1">Debug</Typography>
                    <FormGroup row={!isSm}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={inHtml}
                            onChange={({ target: { checked } }) =>
                              setInHtml(checked)
                            }
                          />
                        }
                        label="Imprimir em HTML"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={retDados}
                            onChange={({ target: { checked } }) =>
                              setRetDados(checked)
                            }
                          />
                        }
                        label="Retornar dados da consulta"
                      />
                    </FormGroup>
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} sm={4} md={3}>
                <Box sx={{ ...styles.fieldset, p: 1, mb: 1 }}>
                  <Typography variant="subtitle1">Etapa</Typography>
                  <Controller
                    control={control}
                    name="etapa"
                    render={({ field, fieldState }) => {
                      const nomeEtapa =
                        sistemaAvaliacao?.nomeEtapa ||
                        escola.nomeEtapa ||
                        "Bimestre";
                      return (
                        <TextField
                          {...field}
                          select
                          label={nomeEtapa}
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                          InputLabelProps={{ shrink: true }}
                          SelectProps={{ displayEmpty: true }}
                        >
                          {etapasFiltradas.map((etapa) => (
                            <MenuItem key={etapa.etapa} value={etapa.etapa}>
                              {etapa.etapa}º {nomeEtapa}
                            </MenuItem>
                          ))}
                        </TextField>
                      );
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={8} md={9}>
                <Box sx={{ ...styles.fieldset, p: 1, mb: 1 }}>
                  <Typography variant="subtitle1">Aluno</Typography>
                  <Controller
                    control={control}
                    name="idAluno"
                    render={({ field, fieldState }) => {
                      if (alunos.loading || alunos.data.length == 0) {
                        return (
                          <TextField
                            label="Alunos"
                            disabled
                            defaultValue="Carregando"
                          />
                        );
                      }
                      return (
                        <TextField
                          {...field}
                          select
                          label="Alunos"
                          value={field.value || ""}
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                          InputLabelProps={{ shrink: true }}
                          SelectProps={{ displayEmpty: true }}
                          onChange={({ target: { value } }) =>
                            setValue(
                              "idAluno",
                              value ? parseInt(value, 10) : null
                            )
                          }
                        >
                          <MenuItem value="">Todos os alunos</MenuItem>
                          {alunos.data.map((aluno, index) => (
                            <MenuItem
                              key={`aluno-${index}`}
                              value={aluno.uid?.toString()}
                            >
                              {aluno.nome?.rUpper()}
                            </MenuItem>
                          ))}
                        </TextField>
                      );
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} lg={6}>
                <Box
                  sx={{
                    ...styles.fieldset,
                    p: 1,
                    mb: 1,
                    borderColor: errors.idModelo
                      ? (theme) => theme.palette.error.main
                      : undefined,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    color={errors.idModelo ? "error" : undefined}
                  >
                    Relatórios
                  </Typography>
                  <List
                    disablePadding
                    sx={({ spacing }) => ({
                      maxHeight: spacing(44),
                      overflowY: "auto",
                    })}
                  >
                    {listaRelatoriosBoletinsConferencia
                      .sort((a, b) => a.nome.localeCompare(b.nome))
                      .map((relatorio, index, arr) => {
                        const ultimoRel = index == arr.length - 1;
                        return relatorio.modelos
                          .filter((f) => f.professorAcessa)
                          .map((modelo, index, arr) => {
                            const ultimoMod = index == arr.length - 1;
                            const selecionado = modelo.id == idModelo;
                            return (
                              <ListItem
                                key={`modelo-${modelo.id}`}
                                disablePadding
                                divider={!ultimoRel || !ultimoMod}
                              >
                                <ListItemButton
                                  onClick={() =>
                                    handleSelectRel(relatorio, modelo)
                                  }
                                >
                                  <ListItemIcon>
                                    {selecionado ? (
                                      <RadioMarkedIcon color="primary" />
                                    ) : (
                                      <RadioBlankIcon />
                                    )}
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={`${relatorio.nome} - ${modelo.nome}`}
                                  />
                                </ListItemButton>
                              </ListItem>
                            );
                          });
                      })
                      .flatMap((m) => m)}
                  </List>
                  {errors.idModelo?.message && (
                    <Typography color="error" variant="caption">
                      {errors.idModelo?.message}
                    </Typography>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} lg={6}>
                <Box sx={{ ...styles.fieldset, p: 1, mb: 1 }}>
                  <Typography variant="subtitle1">Apresentação</Typography>
                  <Grid container>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="cFrequencia"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("cFrequencia") !=
                                  true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .cFrequencia.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="cGrade"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("cGrade") != true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields.cGrade
                                .spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="alunoPorPagina"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes(
                                    "alunoPorPagina"
                                  ) != true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .alunoPorPagina.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="materiaAgrupada"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes(
                                    "materiaAgrupada"
                                  ) != true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .materiaAgrupada.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="alunoPorLinha"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("alunoPorLinha") !=
                                  true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .alunoPorLinha.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="alunoFinal"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("alunoFinal") !=
                                  true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .alunoFinal.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="semCabecalho"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("semCabecalho") !=
                                  true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .semCabecalho.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="verso"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("verso") != true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields.verso
                                .spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="comNota"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("comNota") != true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields.comNota
                                .spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="controleNotas"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("controleNotas") !=
                                  true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .controleNotas.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="ocorrenciaPorLinha"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes(
                                    "ocorrenciaPorLinha"
                                  ) != true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .ocorrenciaPorLinha.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="matrículaPrincipal"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes(
                                    "matrículaPrincipal"
                                  ) != true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .matrículaPrincipal.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="dependendiaAdaptacao"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes(
                                    "dependendiaAdaptacao"
                                  ) != true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .dependendiaAdaptacao.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="notasBaixas"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("notasBaixas") !=
                                  true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .notasBaixas.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="grafico"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("grafico") != true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields.grafico
                                .spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="imprimirFoto"
                        render={({ field }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value ?? false}
                                disabled={
                                  modelo?.habilita?.includes("imprimirFoto") !=
                                  true
                                }
                              />
                            }
                            label={
                              yupFiltroRelatorioNotaConferencia.fields
                                .imprimirFoto.spec.label
                            }
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Form>
        </DialogContent>
        <DialogActions>
          <Button
            color="inherit"
            startIcon={<ConfigIcon />}
            onClick={openPageConfig}
          >
            Configurar página
          </Button>
          <Button onClick={close} color={"secondary"}>
            Fechar
          </Button>
          <LoadingButton
            type="submit"
            variant="outlined"
            form="relatorio-form"
            loading={submiting}
          >
            Visualizar
          </LoadingButton>
        </DialogActions>
      </Box>
    </>
  );
};
